// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import vBlur from 'v-blur'
import App from './App'
import router from './router'
import store from './store';
import VueApexCharts from 'vue-apexcharts'
import VueCurrencyInput from 'vue-currency-input'
import ToggleButton from 'vue-js-toggle-button'

// import './components/home/MapManagementPlatform.css';

// Vue Good Table
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';

import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faArrowsAlt,
  faArrowsAltH,
  faBars,
  faBell,
  faCloudUploadAlt,
  faCalendar,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faChartLine,
  faCaretUp,
  faChartPie,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboard,
  faClipboardCheck,
  faCodeBranch,
  faCog,
  faCopy,
  faDatabase,
  faDownload,
  faDrawPolygon,
  faEraser,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faEllipsisH,
  faFilter,
  faGlobe,
  faGlobeAmericas,
  faGripVertical,
  faHashtag,
  faHdd,
  faHome,
  faIndent,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLightbulb,
  faList,
  faLock,
  faLockOpen,
  faLongArrowAltUp,
  faMap,
  faMinus,
  faOutdent,
  faPaperPlane,
  faPenSquare,
  faPencilAlt,
  faPlus,
  faRoad,
  faRuler,
  faShoppingCart,
  faSearch,
  faServer,
  faSignOutAlt,
  faSpinner,
  faStreetView,
  faStickyNote,
  faTable,
  faTasks,
  faThList,
  faTimes,
  faTrash,
  faUser,
  faUserPlus,
  faUpload,
  faWindowClose,
  faWindowMaximize,
  faWindowMinimize,
  faSync,
  faSyncAlt,
  faWrench,
  faSlidersH,
  faCrop,
  faHistory,
  faArrowUp,
  faArrowLeft,
  faArrowAltCircleLeft,
  faHandPointLeft,
  faBroom,
  faBrush,
  faFileImport,
  faFileUpload,
  faKeyboard,
  faRoute,
  faChartBar,
  faStop,
  faRedoAlt,
  faQuestion,
  faChartArea,
  faHandPointer,
  faRedo,
  faPaintBrush,
  faCamera,
  faClipboardList,
  faTruck,
  faUsersCog,
  faShieldAlt,
  faTag,
  faRobot,
  faFileCode,
  faExpand,
  faSearchLocation,
  faCalendarAlt,
  faPen,
  faUserCog,
  faMapMarkerAlt,
  faFileAlt,
  faImages,
  faVideo
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
  faCircleLeft, 
  faCircleRight,
  faXmarkCircle
} from '@fortawesome/free-regular-svg-icons'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import IdleVue from 'idle-vue'
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Global UI scale for smaller viewports (MacBooks, high-DPI laptops)
import './styles/responsive.css'
import {ModalPlugin} from 'bootstrap-vue'

library.add(
  faAngleDown,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faArrowsAlt,
  faArrowsAltH,
  faArrowLeft,
  faBars,
  faBell,
  faCloudUploadAlt,
  faCalendar,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faChartLine,
  faCaretUp,
  faChartPie,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboard,
  faClipboardCheck,
  faCodeBranch,
  faCog,
  faCopy,
  faDatabase,
  faDownload,
  faDrawPolygon,
  faEraser,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faEllipsisH,
  faFilter,
  faGlobe,
  faGlobeAmericas,
  faGripVertical,
  faHandPointer,
  faHdd,
  faHashtag,
  faHome,
  faIndent,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faList,
  faLock,
  faLockOpen,
  faLongArrowAltUp,
  faMap,
  faMinus,
  faOutdent,
  faPaperPlane,
  faPenSquare,
  faPencilAlt,
  faPlus,
  faRoad,
  faRuler,
  faShoppingCart,
  faSearch,
  faServer,
  faSignOutAlt,
  faSpinner,
  faStreetView,
  faStickyNote,
  faTable,
  faTasks,
  faThList,
  faTimes,
  faTrash,
  faUpload,
  faUser,
  faUserPlus,
  faWindowClose,
  faWindowMaximize,
  faWindowMinimize,
  faWrench,
  faSync,
  faSyncAlt,
  faSlidersH,
  faCrop,
  faHistory,
  faKey,
  faArrowUp,
  faArrowAltCircleLeft,
  faHandPointLeft,
  faBroom,
  faBrush,
  faFileImport,
  faFileUpload,
  faKeyboard,
  faRedo, 
  faRoute,
  faStop,
  faRedoAlt,
  faKeyboard,
  faQuestion,
  faChartArea,
  faPaintBrush,
  faCamera,
  faClipboardList,
  faTruck,
  faUsersCog,
  faShieldAlt,
  faTag,
  faRobot,
  faFileCode,
  faExpand,
  faSearchLocation,
  faCalendarAlt,
  faPen,
  faUserCog,
  faMapMarkerAlt,
  faFileAlt,
  faImages,
  faVideo
)

library.add(
  faCircleLeft, 
  faCircleRight,
  faXmarkCircle,
  faThumbsUp, 
  faThumbsDown
)


Vue.component('fa', FontAwesomeIcon)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueApexCharts)
Vue.use(VueCurrencyInput)
Vue.component('apexchart', VueApexCharts)
Vue.use(ToggleButton)

// Make BootstrapVue available throughout project
Vue.use(BootstrapVue)
Vue.use(ModalPlugin)
Vue.use(IconsPlugin)

Vue.use(Vuex)
Vue.use(vBlur)

Vue.use(VueGoodTablePlugin);

window.Vue = Vue

Vue.use(IdleVue, {
  idleTime: 2000,
  store
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#web-platform-mountpoint',
  router,
  store,
  components: {App},
  template: '<App/>'
})
